import PublicationButton from '../../templates/PublicationButton'
import {LIKE_ICON} from '../../../ui-kit/helpers/icons/like'
import ReactionPanel from '../../organism/ReactionPanel'
import {useEffect, useState} from 'react'
import FadePopUpTop from '../../../ui-kit/components/wrappers/animations/PopUpTop'
import {ReactionContext} from '../../../helpers/context'
import {reactionsData} from '../../../helpers/data/reactions-data'

const ReactionButton = ({tiny}) => {
  const [showReactions, setShowReactions] = useState(false)
  const [reaction, setReaction] = useState({title: 'Me gusta', icon: LIKE_ICON})

  const resetReactionState = () => {
    if (reaction?.name) setReaction({title: 'Me gusta', icon: LIKE_ICON})
    else setReaction(reactionsData['LIKE'])
  }

  useEffect(() => {}, [reaction?.name])

  return (
    <ReactionContext.Provider value={{setReaction}}>
      <div
        className="reaction-button"
        onMouseOver={() => setShowReactions(true)}
        onMouseOut={() => setShowReactions(false)}
      >
        <PublicationButton
          className={`comment ${reaction?.name}`}
          tiny={tiny}
          text={reaction?.title}
          icon={reaction?.icon}
          onClick={resetReactionState}
          isProud={reaction?.name === 'proud'}
        />
        <FadePopUpTop className="fade-container" show={showReactions}>
          <ReactionPanel />
        </FadePopUpTop>
      </div>
    </ReactionContext.Provider>
  )
}

ReactionButton.propTypes = {}

export default ReactionButton
